module.exports = __webpack_public_path__ + "img/fashion_71.ca586c17.jpg";